import { Chip, useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';
import v2Theme from 'theme/v2Theme';

export const GAME_PLATFORMS = Object.freeze({
  desktop: 'desktop',
  mobile: 'mobile',
});

// The V2 responsive contract treats widths below 768px as mobile.
export const mobileGamePlatformQuery = v2Theme.breakpoints
  .down('md')
  .replace(/^@media\s*/, '');

export const isGameSupportedOnPlatform = (game, platform) =>
  !game ||
  !Array.isArray(game.supportedPlatforms) ||
  game.supportedPlatforms.includes(platform);

export const isDesktopOnlyGame = (game) =>
  Array.isArray(game && game.supportedPlatforms) &&
  game.supportedPlatforms.length === 1 &&
  game.supportedPlatforms[0] === GAME_PLATFORMS.desktop;

export const useGamePlatform = () => {
  const isMobile = useMediaQuery(mobileGamePlatformQuery, { noSsr: true });
  return isMobile ? GAME_PLATFORMS.mobile : GAME_PLATFORMS.desktop;
};

export const GamePlatformBadge = ({ game }) => {
  if (!isDesktopOnlyGame(game)) return null;

  return (
    <Chip
      label="Desktop Only"
      aria-label={`${game.title}: Desktop Only`}
      variant="outlined"
      size="small"
      sx={{
        color: '#DCEEFF',
        borderColor: 'rgba(94,202,255,0.52)',
        backgroundColor: 'rgba(7,25,38,0.82)',
      }}
    />
  );
};

GamePlatformBadge.propTypes = {
  game: PropTypes.shape({
    supportedPlatforms: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string.isRequired,
  }).isRequired,
};
